var _a;
import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { CheckSmall } from '../../icons/icons/CheckSmall';
import { RejectedSmall } from '../../icons/icons/RejectedSmall';
import { ToggleButton } from './ToggleButton';
import { ToggleOption } from './ToggleOption';
import { ToggleIcon } from './ToggleIcon';
import { ToggleSwitch } from './ToggleSwitch';
var BLOCKED_SHAKING_DURATION = 650;
export var ToggleComponent = styled((_a = /** @class */ (function (_super) {
        __extends(ToggleComponent, _super);
        function ToggleComponent(props) {
            var _this = _super.call(this, props) || this;
            _this.componentWillUnmount = function () {
                if (_this.shakeTimeout) {
                    clearTimeout(_this.shakeTimeout);
                }
            };
            _this.onToggle = function (event) {
                var _a = _this.props, isDisabled = _a.isDisabled, value = _a.value, onChange = _a.onChange;
                event.preventDefault();
                if (isDisabled) {
                    _this.shake();
                    return;
                }
                onChange(event, !value);
            };
            _this.shake = function () {
                _this.setState({ shaking: true });
                _this.shakeTimeout = window.setTimeout(function () {
                    _this.setState({ shaking: false });
                }, BLOCKED_SHAKING_DURATION);
            };
            _this.state = {
                shaking: false,
            };
            return _this;
        }
        ToggleComponent.prototype.render = function () {
            var _a = this.props, id = _a.id, name = _a.name, value = _a.value, _b = _a.variant, variant = _b === void 0 ? 'decision' : _b, _c = _a.size, size = _c === void 0 ? 'large' : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.hasError, hasError = _e === void 0 ? false : _e, onChange = _a.onChange, className = _a.className, label = _a.label, htmlAttributes = __rest(_a, ["id", "name", "value", "variant", "size", "isDisabled", "hasError", "onChange", "className", "label"]);
            var _f = this.state.shaking, shaking = _f === void 0 ? false : _f;
            return (React.createElement(ToggleButton, __assign({}, htmlAttributes, { id: id, name: name, onClick: this.onToggle, isTrue: value, isDisabled: isDisabled, variant: variant, size: size, hasError: hasError, role: "switch", "aria-checked": value, "aria-label": label }),
                React.createElement(ToggleOption, { forValue: false, isTrue: value, size: size, alignRight: true },
                    React.createElement(ToggleIcon, { Icon: RejectedSmall, isDisabled: isDisabled, isTrue: value })),
                React.createElement(ToggleOption, { forValue: true, isTrue: value, size: size },
                    React.createElement(ToggleIcon, { Icon: CheckSmall, isDisabled: isDisabled, isTrue: value })),
                React.createElement(ToggleSwitch, { isTrue: value, isDisabled: isDisabled, variant: variant, size: size, isShaking: shaking })));
        };
        return ToggleComponent;
    }(React.Component)),
    _a.propTypes = {
        id: PropTypes.string.isRequired,
        value: PropTypes.bool.isRequired,
        name: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        size: PropTypes.oneOf(['large', 'small']),
        variant: PropTypes.oneOf(['decision', 'danger']),
        isDisabled: PropTypes.bool,
        hasError: PropTypes.bool,
        label: PropTypes.string,
        className: PropTypes.string,
    },
    _a))();
//# sourceMappingURL=ToggleComponent.js.map